import React, { useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const OtpVerification = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isVerified, setIsVerified] = useState(false);

  // Function to handle sending OTP
  const sendOtp = async () => {
    let formattedNumber = phoneNumber.trim(); 
    
    // Ensure phoneNumber starts with +91
    if (!formattedNumber.startsWith("+91")) {
      if (formattedNumber.startsWith("91")) {
        formattedNumber = `+${formattedNumber}`; 
      } else {
        formattedNumber = `+91${formattedNumber}`; 
      }
    }

    try {
      const response = await axios.post("http://localhost:5000/api/send-otp", { phoneNumber: formattedNumber });
      if (response.data.success) {
        setIsOtpSent(true);
        toast.success("OTP Sent!"); // Show success message
      } else {
        toast.error("Failed to send OTP: " + response.data.message); // Show error message
      }
    } catch (error) {
      console.error("Error sending OTP", error);
      toast.error("Error sending OTP: " + error.message); // Show error message
    }
  };

  // Function to handle verifying OTP
  const verifyOtp = async () => {
    let formattedNumber = phoneNumber.trim();

    // Ensure phoneNumber starts with +91
    if (!formattedNumber.startsWith("+91")) {
        formattedNumber = `+91${formattedNumber}`; // Reformat before sending
    }

    try {
        console.log(`Verifying OTP for ${formattedNumber} with entered OTP: ${otp}`);
        const response = await axios.post("http://localhost:5000/api/verify-otp", { phoneNumber: formattedNumber, otp });
        console.log("Response from verification:", response.data);

        if (response.data.success) {
            setIsVerified(true);
            toast.success("OTP Verified!"); // Show success message
        } else {
            toast.error("OTP verification failed: " + response.data.message); // Show error message
        }
    } catch (error) {
        console.error("Error verifying OTP", error);
        toast.error("Error verifying OTP"); // Show error message
    }
  };

  return (
    <div className="text-center mt-10">
      <input
        type="text"
        placeholder="Enter phone number"
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
      />
      <button  className='text-white bg-[#225B4B] md:px-4 py-2 w-44 rounded-lg font-serif m-4'  onClick={sendOtp}>Send OTP</button>

      {isOtpSent && (
        <div>
          <input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
          />
          <button  className='text-white bg-[#225B4B] md:px-4 py-2 w-44 rounded-lg font-serif m-4'  onClick={verifyOtp}>Verify OTP</button>
        </div>
      )}

      {isVerified && (
       <div className="flex justify-center items-center ">
       <div className="text-center">
         <h2 className="mt-6 text-4xl">QR Code</h2>
         <img src="images/upi.png" alt="QR Code" className="mx-auto " />
       </div>
     </div>
      )}

      <ToastContainer />
    </div>
  );
};

export default OtpVerification;
